import { z } from 'zod';
import {
  batchStageZod,
  batchTypeZod,
  pipelineZod,
} from 'packages/lib/api/annotations/contract/enums';

export const sampleGroupZod = z.object({
  token: z.string(),
  properties: z.nullable(z.string()),
  name: z.nullable(z.string()),
  tag: z.nullable(z.string()),
  owner: z.nullable(z.string()),
  description: z.nullable(z.string()),
  batchType: batchTypeZod,
  pipeline: pipelineZod,
  startedAt: z.nullable(z.string().datetime()),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  comments: z.nullable(z.string()),
  stage: batchStageZod,
  workflowToken: z.nullable(z.string()),
  finalAt: z.nullable(z.string().datetime()),
  lastAnnotatedAt: z.nullable(z.string().datetime()),
  pipelineToken: z.string(),
  requestId: z.string().nullable(),
  requestSize: z.coerce.number().nullable(),
});

export const sampleGroupsZod = z.array(sampleGroupZod);

export type SampleGroup = z.infer<typeof sampleGroupZod>;
export type SampleGroups = z.infer<typeof sampleGroupsZod>;

export const dataRequestZod = z.object({
  token: z.string(),
  requestId: z.string(),
  sampleGroups: sampleGroupsZod,
  progress: z.string(),
  totalTasks: z.string(),
});
export type DataRequest = z.infer<typeof dataRequestZod>;

export const dataRequestsRespZod = z.array(sampleGroupZod).transform((d) => {
  return d.reduce((acc, curr) => {
    if (curr.requestId) {
      const entry = acc.find((e) => e.requestId === curr.requestId);
      if (!entry) {
        acc.push({
          token: curr.requestId,
          requestId: curr.requestId,
          sampleGroups: [curr],
          progress: '10',
          totalTasks: '-1',
        });
      } else {
        entry.sampleGroups.push(curr);
      }
    }
    return acc;
  }, [] as DataRequest[]);
});
export type DataRequests = z.infer<typeof dataRequestsRespZod>;
